import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * PARA-owned loading state facade.
 *
 * PARA must not import classic GT's `LoaderService` (see para isolation rules). This keeps the
 * public API narrow and matches only what PARA currently needs.
 */
@Injectable({ providedIn: 'root' })
export class ParaLoadingService {
	/** Global HTTP loading (typically driven by an interceptor). */
	public readonly isLoading = new BehaviorSubject<boolean>(false);

	/** PARA org-tree / filter loading indicator. */
	public readonly loadingGrowthChart$ = new BehaviorSubject<boolean>(false);

	/** PARA progress table loading indicator. */
	public readonly loadingProgressTable$ = new BehaviorSubject<boolean>(false);

	/** PARA student time graph loading indicator. */
	public readonly loadingStudentTimeGraph$ = new BehaviorSubject<boolean>(false);

	public setLoading(value: boolean): void {
		this.isLoading.next(!!value);
	}

	public setLoadingGrowthChart(load: boolean): void {
		this.loadingGrowthChart$.next(!!load);
	}

	public setLoadingProgressTable(load: boolean): void {
		this.loadingProgressTable$.next(!!load);
	}

	public setLoadingStudentTimeGraph(load: boolean): void {
		this.loadingStudentTimeGraph$.next(!!load);
	}

	get loading(): boolean {
		return this.isLoading.value;
	}

	get loadingProgressTable(): boolean {
		return this.loadingProgressTable$.value;
	}

	get loadingStudentTimeGraph(): boolean {
		return this.loadingStudentTimeGraph$.value;
	}

	get loadingGrowthChart(): boolean {
		return this.loadingGrowthChart$.value;
	}
}

